export const DEFAULT_ERROR_MESSAGE = 'Ошибка при загрузке профиля пользователя';
